<template>
  <div>
    <vue-modal :open="message.length > 0">
    <div class="bax-modal-content bax-modal-icon-content text-center">
      <div class="bax-icon bax-remove d-flex align-items-center justify-content-center">
        <i class="icon-exclamation"></i>
      </div>
      <h2>An error has occurred with your order</h2>
      <p  v-html="message"></p>
      <div class="bax-modal-action-items">
            <a href="#" class="bax-btn bax-btn-orange mt-3 mt-md-0" @click.prevent="close">
              Back to order
            </a>
      </div>
    </div>
    </vue-modal>
  </div>
</template>


<script>

export default {
  name: 'GenericErrorModal',
  props: {
    message: {
      type: String,
    },
  },
  data() {
    return {
    };
  },
  methods: {
    close() {
      this.$emit('ErrorAccepted');
    },
  },
};
</script>
